import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './LegalPage.css';

export default function PrivacyPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="legal-page">
      <div className="legal-container">
        <Link to="/" className="legal-back">← Back to Godly Match</Link>
        <h1>Privacy Policy</h1>
        <p className="legal-effective">Effective date: 7 May 2026 · Last updated: 7 May 2026</p>

        <h2>1. Who We Are</h2>
        <p>Godly Match ("we", "us", "our") is a Christian dating platform operated by GodlyMatchLLC, based in Nigeria. You can reach us at privacy@godlymatch.org.</p>

        <h2>2. What Information We Collect</h2>
        <h3>Information you give us directly</h3>
        <ul>
          <li>Name, email address, and password when you register</li>
          <li>Date of birth, gender, denomination, faith level, and home church</li>
          <li>Profile photos you upload</li>
          <li>Bio text and interests you enter</li>
          <li>Messages you send to other users</li>
        </ul>
        <h3>Information collected automatically</h3>
        <ul>
          <li>Your approximate location (with your permission) to calculate distances</li>
          <li>Device type, browser, and operating system</li>
          <li>How you use the app — pages visited, features used, time spent</li>
          <li>IP address</li>
        </ul>

        <h2>3. How We Use Your Information</h2>
        <ul>
          <li>Create and manage your account</li>
          <li>Show you compatible matches based on your preferences</li>
          <li>Enable messaging between matched users</li>
          <li>Send transactional emails (verification, password resets, match alerts)</li>
          <li>Moderate content and enforce our Community Guidelines</li>
          <li>Process subscription payments through Flutterwave</li>
          <li>Improve the app based on usage patterns</li>
          <li>Comply with legal obligations</li>
        </ul>

        <h2>4. Who We Share Your Information With</h2>
        <p>We do not sell your personal data. We share it only with trusted service providers:</p>
        <ul>
          <li><strong>Cloudinary</strong> — stores and delivers your profile photos</li>
          <li><strong>Resend</strong> — sends transactional emails on our behalf</li>
          <li><strong>Firebase (Google)</strong> — delivers push notifications</li>
          <li><strong>Amazon Web Services</strong> — photo content moderation</li>
          <li><strong>Flutterwave</strong> — processes subscription payments</li>
          <li><strong>Sentry</strong> — anonymised error monitoring</li>
        </ul>
        <p>All providers are contractually required to protect your data and use it only for the services they provide to us.</p>

        <h2>5. Your Profile Visibility</h2>
        <p>Your profile is visible to other registered users of Godly Match. You can control what information appears through the Settings page. Distance is shown as an approximate range — never your exact location.</p>

        <h2>6. Data Retention</h2>
        <p>We keep your data while your account is active. If you delete your account, we delete your personal data within 30 days, except where we are legally required to retain it (e.g. payment records).</p>

        <h2>7. Your Rights</h2>
        <p>Depending on where you live, you may have the right to access, correct, delete, or export your personal data, or to object to how we process it. Email privacy@godlymatch.org to exercise any of these rights.</p>

        <h2>8. Children</h2>
        <p>Godly Match is strictly for users aged 18 and over. We do not knowingly collect data from minors. If you believe a minor has registered, contact support@godlymatch.org immediately.</p>

        <h2>9. Security</h2>
        <p>We protect your data with encrypted passwords (bcrypt), HTTPS on all connections, and JWT-based authentication. If you believe your account has been compromised, contact us immediately.</p>

        <h2>10. Changes to This Policy</h2>
        <p>We will notify you by email or in-app notice if we make material changes. Continued use after changes take effect means you accept the updated policy.</p>

        <h2>11. Contact</h2>
        <p>privacy@godlymatch.org</p>
      </div>
    </div>
  );
}